import { render, staticRenderFns } from "./ActionButtonsSection.vue?vue&type=template&id=c087a8b2&scoped=true"
import script from "./ActionButtonsSection.vue?vue&type=script&lang=js"
export * from "./ActionButtonsSection.vue?vue&type=script&lang=js"
import style0 from "./ActionButtonsSection.vue?vue&type=style&index=0&id=c087a8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c087a8b2",
  null
  
)

export default component.exports